import { css, mediaQueries } from '@eti/styles';
export const priceWrapperStyles = css`
  width: 100%;
`;
export const priceLabelStyles = css`
  margin-inline-start: auto;
  margin-top: auto;
`;
export const priceStyles = css`
  margin-inline-start: auto;
`;
export const animationProps = isMobile => ({
  animate: {
    height: 'auto',
    opacity: 1
  },
  transition: {
    type: 'tween',
    duration: isMobile ? 0.2 : 0
  }
});
export const standardGrid = css`
  column-gap: 8px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(3, auto);

  @media ${mediaQueries.medium.up} {
    justify-content: end;
  }

  .priceLabel {
    grid-area: 2 / 1 / 3 / 2;
    margin-top: 30px;

    @media ${mediaQueries.small.only} {
      grid-area: 2 / 2 / 2 / 3;
      margin-top: 0;
    }
  }

  .price {
    grid-area: 3 / 1 / 4 / 2;
    text-align: end;

    @media ${mediaQueries.small.only} {
      grid-area: 3 / 2 / 3 / 3;
      margin-bottom: 8px;
    }
  }

  .selection {
    grid-area: 1 / 2 / 2 / 3;
    margin-bottom: 8px;

    @media ${mediaQueries.small.only} {
      grid-area: 2 / 1 / 3 / 2;
      margin-bottom: 0;
    }
  }

  .buttonWrapper {
    grid-area: 2 / 2 / 4 / 3;
    width: max-content;

    @media ${mediaQueries.small.only} {
      grid-area: 3 / 1 / 4 / 3;
      width: auto;
    }
  }

  legend {
    @media ${mediaQueries.small.only} {
      max-width: 75%;
    }
  }

  .children {
    display: contents;
  }

  .validation {
    grid-area: 5 / 2 / 6 / 3;
    margin-top: 8px;

    @media ${mediaQueries.small.only} {
      grid-area: 4 / 1 / 5 / 3;
    }
  }
`;
//# sourceMappingURL=styles.js.map